import $ from 'jquery';

const node = 12;
const siteId = 33465;
const apiRequestUrl = `https://api-node${node}.calltouch.ru/calls-service/RestAPI/requests/${siteId}/register/`;
const mapFields = {
  'response[name]': 'fio',
  'response[phone]': 'phoneNumber',
  'response[email]': 'email',
  'response[message]': 'comment',
};

const callTouchData = (data) => {
  const callTouchData = {
    subject: 'Заявка с сайта',
    sessionId: window.call_value
  };

  for (const [name, value] of data.entries())
    if (mapFields[name])
      callTouchData[mapFields[name]] = value;

  return callTouchData;
};

export const sendCallTouchRequest = (data) => {
  $.ajax({
    url: apiRequestUrl,
    dataType: 'json',
    type: 'POST',
    data: callTouchData(data)
  });
};
